import get from 'lodash.get';

export const selectConfigureRatesModel = (state) => get(state, 'configureRatesModel');
export const selectIsModalOpenStatus = (state) => get(state, 'isModalOpen');
